/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreakFreezeEarnRate } from './StreakFreezeEarnRate';
import {
    StreakFreezeEarnRateFromJSON,
    StreakFreezeEarnRateFromJSONTyped,
    StreakFreezeEarnRateToJSON,
    StreakFreezeEarnRateToJSONTyped,
} from './StreakFreezeEarnRate';

/**
 * Forgiveness configuration — how the streak protects against missed windows
 * @export
 * @interface StreakForgiveness
 */
export interface StreakForgiveness {
    /**
     * Extra windows before the streak breaks (0 = strict)
     * @type {number}
     * @memberof StreakForgiveness
     */
    gracePeriodWindows?: number;
    /**
     * Maximum freezes a user can hold (0 = no freezes)
     * @type {number}
     * @memberof StreakForgiveness
     */
    freezesMax?: number;
    /**
     * 
     * @type {StreakFreezeEarnRate}
     * @memberof StreakForgiveness
     */
    freezeEarnRate?: StreakFreezeEarnRate;
    /**
     * Fuel cost per freeze purchase
     * @type {number}
     * @memberof StreakForgiveness
     */
    freezeCostFuel?: number;
    /**
     * Auto-consume a freeze on miss (no user action needed)
     * @type {boolean}
     * @memberof StreakForgiveness
     */
    autoFreeze?: boolean;
    /**
     * Whether users can pause this streak
     * @type {boolean}
     * @memberof StreakForgiveness
     */
    allowPause?: boolean;
    /**
     * Max consecutive days of pause (null = unlimited)
     * @type {number}
     * @memberof StreakForgiveness
     */
    maxPauseDays?: number;
}



/**
 * Check if a given object implements the StreakForgiveness interface.
 */
export function instanceOfStreakForgiveness(value: object): value is StreakForgiveness {
    return true;
}

export function StreakForgivenessFromJSON(json: any): StreakForgiveness {
    return StreakForgivenessFromJSONTyped(json, false);
}

export function StreakForgivenessFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakForgiveness {
    if (json == null) {
        return json;
    }
    return {
        
        'gracePeriodWindows': json['gracePeriodWindows'] == null ? undefined : json['gracePeriodWindows'],
        'freezesMax': json['freezesMax'] == null ? undefined : json['freezesMax'],
        'freezeEarnRate': json['freezeEarnRate'] == null ? undefined : StreakFreezeEarnRateFromJSON(json['freezeEarnRate']),
        'freezeCostFuel': json['freezeCostFuel'] == null ? undefined : json['freezeCostFuel'],
        'autoFreeze': json['autoFreeze'] == null ? undefined : json['autoFreeze'],
        'allowPause': json['allowPause'] == null ? undefined : json['allowPause'],
        'maxPauseDays': json['maxPauseDays'] == null ? undefined : json['maxPauseDays'],
    };
}

export function StreakForgivenessToJSON(json: any): StreakForgiveness {
    return StreakForgivenessToJSONTyped(json, false);
}

export function StreakForgivenessToJSONTyped(value?: StreakForgiveness | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gracePeriodWindows': value['gracePeriodWindows'],
        'freezesMax': value['freezesMax'],
        'freezeEarnRate': StreakFreezeEarnRateToJSON(value['freezeEarnRate']),
        'freezeCostFuel': value['freezeCostFuel'],
        'autoFreeze': value['autoFreeze'],
        'allowPause': value['allowPause'],
        'maxPauseDays': value['maxPauseDays'],
    };
}

